import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Home from './page/home';
import Navbar from './components/Navbar';
import Login from './page/login';
import Dashboard from './page/dashboard';
import Tier from './page/tier';
import Program from './page/program';
import Customer from './page/customer';
import Abandoned from './page/abandoned';
import Setting from './page/setting';
import WaysToEarn from './page/addWaysToEarn';
import TierForm from './page/tierForm';
import CustomerDetails from './page/customer/customerDetails';

import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { persistor, store } from './store';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route element={<Navbar />}>
        <Route path='/' element={<Dashboard />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/tier' element={<Tier />} />
        <Route path='/tier/form' element={<TierForm />} />
        <Route path='/program' element={<Program />} />
        <Route path='/customer' element={<Customer />} />
        <Route path='/abandoned' element={<Abandoned />} />
        <Route path='/setting' element={<Setting />} />
        <Route path='/addWaysToEarn' element={<WaysToEarn />} />
        <Route path='/customer-details' element={<CustomerDetails />} />
      </Route>
      <Route path='/login' element={<Login />} />
    </Route>
  )
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Toaster />
        <RouterProvider router={router} />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
